import React from 'react';
import ManageLeaveTable from './ManageLeaveTable';
import '../leaveManagement.scss';

interface ManageLeaveProps {
  searchQuery: string;
}

export default function ManageLeave({ searchQuery }: ManageLeaveProps) {
  return (
    <div>
      <ManageLeaveTable searchQuery={searchQuery} />
    </div>
  );
}
